import { useNavigate } from "react-router-dom";
import { Text, Button } from "@chakra-ui/react";
import { relativeUrl } from "../utils";
import { useConfirmedNavigate } from "../context/Mutation/useConfirmedNavigate";

/**
 * Drop-in replacement for <a> tag or navigate(), using react-router-dom to navigate.
 * Benefits:
 * - Like writing a callback for navigate() -- but simpler, and follows the familiar <a> tag syntax.
 * - Supports right-click allowing the user to open in new tab, or copy the link.
 * 
 * Contains confirm-navigation support. TODO this is a fragile way to do this: 
 * Better to use listening for navigation events, rather than having to plug every navigation option.
 */
export default function A({
  href,
  title,
  children,
  onClick,
  className,
  target,
  shouldConfirm,
  confirmConfig,
  ...props
}) {
  // const navigate = useNavigate();
  const navigate = useConfirmedNavigate();
  if (!onClick) {
    // make internal links relative for the router
    href = relativeUrl(href);
    // detect external links and mailto: links (assumes: internal links are relative so no ":")
    if (href.substring(0, 8).includes(":")) {
      onClick = (e) => {
        e.preventDefault();
        e.stopPropagation();
        window.open(href, target, "noreferrer");
      };
    } else {
      // internal links - use react-router-dom
      onClick = (e) => {
        e.preventDefault();
        e.stopPropagation();
        navigate(href, {
          confirm: shouldConfirm,
          ...confirmConfig,
        });
      };
    }
  }
  return (
    <Text as="a" href={href} onClick={onClick} title={title} className={className} {...props}>
      {children}
    </Text>
  );
}

/**
 * A Button-styled <a> tag.
 */
export function AButton({ href, children, onClick, shouldConfirm = false, confirmConfig = {}, ...props }) {
  return (
    <Button {...props}>
      <A href={href} onClick={onClick} shouldConfirm={shouldConfirm} confirmConfig={confirmConfig}>
        {children}
      </A>
    </Button>
  );
}
